import { AnprVM } from 'shell/view-models/search-anpr';
import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseAnprData } from 'shell/models/person';
import { DateTime } from 'luxon';
import { transformToChoiceDate } from 'shell/components/shared/choice-date/functions';
import { CertificationFormVM } from 'civil-status/view-models/document-birth-form';

export const transformerPersonGeneralityList = (
  response: AxiosResponse<HttpResponse<ResponseAnprData>>
): AnprVM<CertificationFormVM> => {
  return {
    warnings: (response.data.payload?.risposta3002OK?.listaAnomalie?.errore || []).map(
      (warning) => ({
        id: warning.codiceErroreAnomalia,
        value: warning.testoErroreAnomalia,
      })
    ),
    errors: (response.data.payload?.rispostaKO?.listaErrori?.errore || []).map((error) => ({
      id: error.codiceErroreAnomalia,
      value: error.testoErroreAnomalia,
    })),
    persons: (response.data.payload?.risposta3002OK?.listaSoggetti?.datiSoggetto || []).map(
      (person) => {
        const birthChoiceDate = transformToChoiceDate(
          person.generalita?.senzaGiorno,
          person.generalita?.senzaGiornoMese
        );
        const residenceArray = person.residenza || [];

        let birthplace = '';
        // birthplace check for object
        if (person.generalita?.luogoNascita?.localita) {
          birthplace = `${person.generalita?.luogoNascita?.localita.descrizioneLocalita} (${person.generalita?.luogoNascita?.localita.descrizioneStato})`;
        }

        if (person.generalita?.luogoNascita?.comune) {
          birthplace = `${person.generalita?.luogoNascita?.comune.nomeComune} (${person.generalita?.luogoNascita?.comune.siglaProvinciaIstat})`;
        }
        // Residence check for object
        let residence = '';
        // scelgo il primo o è un array?
        if (residenceArray[0]?.indirizzo) {
          residence = `${residenceArray[0]?.indirizzo.comune?.nomeComune || ''} (${
            residenceArray[0]?.indirizzo.comune?.siglaProvinciaIstat || ''
          })`;
        }
        // scelgo il primo o è un array?
        if (residenceArray[0]?.localitaEstera) {
          residence = `${residenceArray[0]?.localitaEstera?.indirizzoEstero?.localita?.descrizioneLocalita} (${residenceArray[0]?.localitaEstera?.indirizzoEstero?.localita?.descrizioneStato})`;
        }

        let state = '';
        // state check for object
        if (residenceArray[0]?.indirizzo?.toponimo) {
          const toponym = residenceArray[0]?.indirizzo?.toponimo;

          const civic = residenceArray[0]?.indirizzo?.numeroCivico;

          state = `${toponym.specie} ${toponym.denominazioneToponimo},${civic?.numero}${
            civic?.esponente1 ? `/${civic.esponente1}${civic.lettera}` : ''
          }`;
        }

        if (person.generalita?.soggettoAIRE && person.generalita?.soggettoAIRE === 'S') {
          state = 'Iscritto AIRE';
        }

        if (person.datiCancellazione && person.datiCancellazione?.descrizioneMotivoCancellazione) {
          state = `${person.datiCancellazione.descrizioneMotivoCancellazione}`;
        }
        return {
          copies: '1',
          applicant: {
            datiSoggetto: person,
            state,
            residence,
            birthplace,
            idSubjectAnpr: person.generalita?.idSchedaSoggettoANPR,
            matricola:
              person.codicePersonaSipo ||
              person.generalita?.idSchedaSoggettoComune?.idSchedaSoggetto ||
              '',
            fiscalCode: person.generalita?.codiceFiscale?.codFiscale || '',
            name: person.generalita?.nome || '',
            surname: person.generalita?.cognome || '',
            birthDate: person.generalita?.dataNascita
              ? DateTime.fromISO(person.generalita?.dataNascita)
              : null,
            withoutSurname: person.generalita?.senzaCognome === '1',
            withoutName: person.generalita?.senzaNome === '1',
            gender: person.generalita?.sesso || '',
            birthChoiceDate: birthChoiceDate,
            isForeign: person.generalita?.luogoNascita?.localita ? true : false,
            foreignState: person.generalita?.luogoNascita?.localita
              ? {
                  id: person.generalita?.luogoNascita?.localita?.codiceStato || '',
                  value: person.generalita?.luogoNascita?.localita?.descrizioneStato || '',
                }
              : null,
            foreignMunicipality: person.generalita?.luogoNascita?.localita
              ? {
                  id: person.generalita?.luogoNascita?.localita?.codiceStato || '',
                  description: person.generalita?.luogoNascita?.localita?.descrizioneLocalita || '',
                  province: person.generalita?.luogoNascita?.localita?.provinciaContea || '',
                }
              : null,
            municipality: person.generalita?.luogoNascita?.comune
              ? {
                  id: person.generalita?.luogoNascita?.comune?.codiceIstat || '',
                  description: person.generalita?.luogoNascita?.comune?.nomeComune || '',
                  province: person.generalita?.luogoNascita?.comune?.siglaProvinciaIstat || '',
                }
              : null,
            documentNumber: person.cartaIdentita?.numero || '',
            documentIssuedDate: person.cartaIdentita?.dataRilascio
              ? DateTime.fromISO(person.cartaIdentita?.dataRilascio)
              : null,
            isForeignDocument: !!person.cartaIdentita?.consolatoRilascio,
            foreignStateDocument: person.cartaIdentita?.consolatoRilascio?.descrizioneConsolato,
            municipalityDocument: person.cartaIdentita?.comuneRilascio
              ? {
                  id: person.cartaIdentita?.comuneRilascio?.codiceIstat || '',
                  description: person.cartaIdentita?.comuneRilascio?.nomeComune || '',
                  province: person.cartaIdentita?.comuneRilascio?.siglaProvinciaIstat || '',
                }
              : null,
          },
          hidden: {
            delete: true,
            edit: true,
          },
        } as CertificationFormVM;
      }
    ) as Array<CertificationFormVM>,
  };
};
